module.exports = __webpack_public_path__ + "static/media/wuxi.80654b57.png";